export const editorCommands: IEditorCommands = {
  r1: {
    id: 'r1',
    ts: 0,
    type: 'soda',
    status: 'success',
    params: {
      prompt: 'make it bigger',
    },
    tsStart: 10,
    tsEnd: 20,
  },
};
